__turbopack_context__.v({
  "className": "jetbrains_mono_957de89d-module__IjALqa__className",
  "variable": "jetbrains_mono_957de89d-module__IjALqa__variable",
});
